<template></template>

<script>
export default {
  data() {
    return {
      intervalId: null,
      lastToastIds: [],
    }
  },
  watch: {
    '$page.props.toasts': function (toasts) {
      if (!Array.isArray(toasts)) return;

      toasts.forEach(toast => {
        let title = toast.title

        if (! title) {
          switch (toast.variant) {
            case 'success':
              title = 'Sukces'
              break
            case 'danger':
              title = 'Błąd'
              break
            case 'warning':
              title = 'Uwaga'
              break
            case 'info':
              title = 'Info'
              break
          }
        }

        if (!this.lastToastIds.includes(toast.id)) {
          this.lastToastIds.push(toast.id)

          this.$bvToast.toast(toast.message, {
            id: toast.id,
            title: title,
            variant: toast.variant || 'primary',
            solid: true,
            autoHideDelay: (toast.variant !== 'success') ? 8000 : 3000,
          })
        }
      })
    },
  },
  created() {
    this.intervalId = setInterval(() => {
      this.lastToastIds.length = 0
    }, 1000*60*60) // 1h
  },
  destroyed() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }
}
</script>
